import { useBreakpoint } from "@chakra-ui/react";

export const LargeBreak = () => {
  const breakpoint = useBreakpoint();
  return <br style={{ display: breakpoint === "xl" || breakpoint === "2xl" ? "block" : "none" }} />;
};

export const SmallBreak = () => {
  const breakpoint = useBreakpoint();
  return <br style={{ display: breakpoint === "base" ? "block" : "none" }} />;
};
export const MediumBreak = () => {
  const breakpoint = useBreakpoint();
  return <br style={{ display: breakpoint === "lg" ? "block" : "none" }} />;
};
